import React, { Component } from 'react'
import { graphql } from 'react-apollo'
import './modal.css'
import EventEditModal from './EventEdit'
import GroupEditModal from './GroupEdit'
import DeleteModal from '../modals/Delete'
import { currentBookPref } from '@/graphql/queries/bookPref'
import { updateEventType, deleteEvent } from '@/graphql/mutations/event'
import {
  newGroup,
  updateCompleteGroup,
  addToGroupsOnGroup,
  deleteGroup
} from '@/graphql/mutations/group'
import { GC_USER_ID, PROJECT_TRACKER_ID } from '@/constants'

import * as moment from 'moment'
import { Modal, Typography, Paper, Button } from 'material-ui'
import List, { ListItem, ListItemText, ListItemIcon } from 'material-ui/List'
import IconButton from 'material-ui/IconButton'
import ClearIcon from 'material-ui-icons/Clear'
import EditIcon from 'material-ui-icons/Edit'
import ChromeReaderModeIcon from 'material-ui-icons/ChromeReaderMode'
import DeleteIcon from 'material-ui-icons/Delete'
import PlayArrowIcon from 'material-ui-icons/PlayArrow'
import AddIcon from 'material-ui-icons/Add'
import CheckIcon from 'material-ui-icons/Check'
import Loading from './Loading'
import ChevronRightIcon from 'material-ui-icons/ChevronRight'

var fromGroupID = ''

@graphql(currentBookPref, {
  name: 'currentBookPref',
  options: () => ({
    variables: {
      userId: global.localStorage.getItem(GC_USER_ID),
      isCurrent: true
    }
  })
})
@graphql(addToGroupsOnGroup, {
  name: 'addToGroupsOnGroup',
  options: {
    refetchQueries: ['routinesQuery', 'groupsQuery', 'groupQuery']
  }
})
@graphql(newGroup, {
  name: 'newGroup',
  options: {
    refetchQueries: ['routinesQuery', 'groupsQuery', 'groupQuery']
  }
})
@graphql(updateCompleteGroup, {
  name: 'updateCompleteGroup',
  options: {
    refetchQueries: ['routinesQuery', 'groupsQuery', 'groupQuery']
  }
})
@graphql(updateEventType, {
  name: 'updateEventType',
  options: {
    refetchQueries: ['eventsQuery']
  }
})
@graphql(deleteEvent, {
  name: 'deleteEvent',
  options: {
    refetchQueries: ['eventsQuery']
  }
})
@graphql(deleteGroup, {
  name: 'deleteGroup',
  options: {
    refetchQueries: ['routinesQuery', 'groupsQuery']
  }
})
export default class EventViewModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      OpenAdd: false,
      OpenTimer: false,
      openEdit: false,
      OpenDelete: false,
      event: '',
      newEvent: '',
      action: '',
      origin: '',
      happenedFromID: '',
      loading: false,
      loadingDel: false,
      loadingCreate: false,
      loadingAddTo: false
    }
  }

  // reset state if the seeded prop is updated
  componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.props.open) {
      this.setState({ open: nextProps.open })
    }

    if (nextProps.event !== this.props.event) {
      this.setState({ event: nextProps.event })
    }
  }

  handleClose = () => {
    this.props.onClose()
    this.setState({
      open: false
    })
  }

  handleCloseAdd = () => {
    this.props.onClose()
    this.setState({
      OpenAdd: false,
      open: false
    })
  }

  handleOpenDelete = () => {
    this.setState({
      OpenDelete: true
    })
  }

  handleCloseDelete = () => {
    this.setState({
      OpenDelete: false
    })
  }

  handleDelete = id => {
    this.setState({ loadingDel: true })
    if (this.state.event.eventType === 'routine') {
      this.props
        .deleteGroup({
          variables: {
            id: id
          }
        })
        .then(() => {
          this.props.onClose()
          this.setState({
            loadingDel: false,
            OpenDelete: false,
            open: false
          })
        })
        .catch(error => {
          console.log(error.message + ' Please refresh.')
          this.props.onClose()
          this.setState({
            loadingDel: false,
            OpenDelete: false,
            open: false
          })
        })
    } else {
      this.props
        .deleteEvent({
          variables: {
            id: id
          }
        })
        .then(() => {
          this.props.onClose()
          this.setState({
            loadingDel: false,
            OpenDelete: false,
            open: false
          })
        })
        .catch(error => {
          console.log(error.message + ' Please refresh.')
          this.props.onClose()
          this.setState({
            loadingDel: false,
            OpenDelete: false,
            open: false
          })
        })
    }
  }

  handleSessionEditDone = (action, origin, tracker) => {
    this.handleDone('planDone')
    this.handleSessionEdit(action, origin, tracker)
  }
  handleSessionEditRoutine = (status, action, origin, tracker) => {
    this.setState({ action: action, origin: origin })
    global.localStorage.setItem(PROJECT_TRACKER_ID, tracker.id)
    if (this.state.event.type === 'recur') {
      // create one and assing fromGroupID
      this.handleCreate(status, action, origin, tracker)
    } else if (this.state.event.type === 'one') {
      fromGroupID = this.state.event.id
      if (status) {
        this.handleComplete(status)
      }
      this.handleSessionAddFromRoutine(
        action,
        origin,
        tracker.type,
        tracker.id,
        tracker.name
      )
    }
  }

  handleSessionEdit = (action, origin, tracker) => {
    this.setState({ action: action })
    if (this.state.event.eventType === 'routine' && action === 'edit') {
      this.setState({
        openEdit: true
      })
    } else {
      this.setState({ origin: origin })
      if (this.state.event.eventType !== 'routine') {
        global.localStorage.setItem(
          PROJECT_TRACKER_ID,
          this.state.event.tracker.id
        )
        if (action === 'add') {
          var newEvent = Object.assign({}, this.state.event)
          newEvent.dataOrigin = origin
          newEvent.eventType = 'happenedFrom:' + this.state.event.eventType
          this.setState({
            happenedFromID: this.state.event.id,
            newEvent: newEvent
          })
        }
      }

      if (origin === 'manualAdd' || action === 'edit') {
        this.setState({
          OpenAdd: true
        })
      } else if (origin === 'alchmeyTimer') {
        this.setState({ OpenTimer: true })
      }
    }
    this.handleClose()
  }

  handleSessionAddFromRoutine = (
    action,
    origin,
    type,
    trackerId,
    trackerName
  ) => {
    this.setState({ newEvent: '' })
    var sE = moment(new Date(this.state.event.startedAt))
    var eE = moment(new Date(this.state.event.completedAt))
    var mins = this.state.event.minutesTotal
    if (sE.isSameOrBefore(eE)) {
      mins = eE.diff(sE, 'minutes')
    } else {
      mins = 0
    }
    switch (type) {
      case 'energy':
        var newEventEnergy = {
          startedAt: sE,
          dataOrigin: origin,
          eventType: 'happenedRoutine:' + fromGroupID,
          options: {
            value: ''
          },
          tracker: {
            id: trackerId,
            type: type,
            name: trackerName
          },
          mood: 0,
          comment: ''
        }

        this.setState({ newEvent: newEventEnergy })
        break
      case 'checked':
      case 'bodyweight':
        var newEventValue = {
          startedAt: sE,
          dataOrigin: origin,
          eventType: 'happenedRoutine:' + fromGroupID,
          options: {
            value: ''
          },
          tracker: {
            id: trackerId,
            type: type,
            name: trackerName
          },
          mood: 0,
          comment: ''
        }

        this.setState({ newEvent: newEventValue })
        break
      case 'reading':
        var bookId = ''
        var bookName = ''
        var bookAuthor = ''
        var bookPrefId = ''
        var bookPrefMaxPage = ''
        var bookPrefPercent = ''
        var bookTotalPages = ''
        var pageStart = ''
        if (
          this.props.currentBookPref.allBookPrefs &&
          this.props.currentBookPref.allBookPrefs.length === 1
        ) {
          bookId = this.props.currentBookPref.allBookPrefs[0].book.id
          bookName = this.props.currentBookPref.allBookPrefs[0].book.name
          bookAuthor = this.props.currentBookPref.allBookPrefs[0].book.author
          bookTotalPages = this.props.currentBookPref.allBookPrefs[0].book
            .totalPages
          bookPrefId = this.props.currentBookPref.allBookPrefs[0].id
          bookPrefMaxPage = this.props.currentBookPref.allBookPrefs[0].maxPage
          bookPrefPercent = this.props.currentBookPref.allBookPrefs[0]
            .percentRead
          if (this.props.currentBookPref.allBookPrefs[0].maxPage > 0) {
            pageStart = this.props.currentBookPref.allBookPrefs[0].maxPage
          }
        }
        var newReading = {
          startedAt: sE,
          completedAt: eE,
          dataOrigin: origin,
          eventType: 'happenedRoutine:' + fromGroupID,
          minutes: mins,
          options: {
            value: '',
            pageStart: pageStart,
            pageEnd: ''
          },
          book: {
            id: bookId,
            name: bookName,
            author: bookAuthor,
            totalPages: bookTotalPages
          },
          bookPref: {
            id: bookPrefId,
            maxPage: bookPrefMaxPage,
            percentRead: bookPrefPercent
          },
          tracker: {
            id: trackerId,
            type: type,
            name: trackerName,
            isDuration: true
          },
          mood: 0,
          comment: ''
        }

        this.setState({ newEvent: newReading })
        break
      case 'project':
        global.localStorage.setItem(PROJECT_TRACKER_ID, trackerId)
        var newProject = {
          startedAt: sE,
          completedAt: eE,
          dataOrigin: origin,
          eventType: 'happenedRoutine:' + fromGroupID,
          minutes: mins,
          task: {
            id: '',
            name: ''
          },
          subtask: {
            id: '',
            name: ''
          },
          tracker: {
            id: trackerId,
            type: type,
            name: trackerName,
            isDuration: true
          },
          mood: 0,
          comment: ''
        }

        this.setState({ newEvent: newProject })
        break
      case 'sleep':
        var newSleep = {
          startedAt: sE,
          completedAt: eE,
          dataOrigin: origin,
          eventType: 'happenedRoutine:' + fromGroupID,
          minutes: mins,
          options: {
            value: '',
            isNap: false,
            brianClearness: 'Normal'
          },
          tracker: {
            id: trackerId,
            type: type,
            name: trackerName,
            isDuration: true
          },
          mood: 0,
          comment: ''
        }
        this.setState({ newEvent: newSleep })
        break

      default:
        var newEventDefault = {
          startedAt: sE,
          completedAt: eE,
          dataOrigin: origin,
          eventType: 'happenedRoutine:' + fromGroupID,
          minutes: mins,
          options: {
            value: ''
          },
          tracker: {
            id: trackerId,
            type: type,
            name: trackerName,
            isDuration: true
          },
          mood: 0,
          comment: ''
        }
        this.setState({ newEvent: newEventDefault })
        break
    }
    if (origin === 'manualAdd' || action === 'edit') {
      this.setState({
        OpenAdd: true
      })
    } else if (origin === 'alchmeyTimer') {
      this.setState({ OpenTimer: true })
    }
    this.handleClose()
  }

  handleCloseEdit = () => {
    this.setState({ openEdit: false })
  }

  handleCloseTimer = () => {
    this.setState({
      OpenTimer: false
    })
  }

  handleAddTo = id => {
    this.setState({ loadingAddTo: true })
    this.props
      .addToGroupsOnGroup({
        variables: {
          groups1GroupId: this.state.event.id,
          groups2GroupId: id
        }
      })
      .then(() => {
        this.setState({ loadingAddTo: false })
        this.handleClose()
      })
      .catch(error => {
        console.log(error.message + ' Please refresh.')
        this.setState({ loadingAddTo: false })
        this.handleClose()
      })
  }

  handleCreate = (status, action, origin, tracker) => {
    this.setState({ loadingCreate: true })
    this.props
      .newGroup({
        variables: {
          name: this.state.event.name,
          startedAt: this.state.event.startedAt,
          completedAt: this.state.event.completedAt,
          minutesTotal: this.state.event.minutesTotal,
          isStared: this.state.event.isStared,
          isDuration: this.state.event.isDuration,
          isPublic: this.state.event.isPublic,
          isCompleted: status,
          color: this.state.event.color,
          type: 'one',
          userId: global.localStorage.getItem(GC_USER_ID)
        }
      })
      .then(data => {
        this.setState({
          loadingCreate: false
        })
        if (action !== '' && origin !== '' && tracker !== '') {
          fromGroupID = data.data.createGroup.id
          this.handleSessionAddFromRoutine(
            action,
            origin,
            tracker.type,
            tracker.id,
            tracker.name
          )
        }

        this.handleAddTo(data.data.createGroup.id)
      })
      .catch(error => {
        console.log(error.message + ' Please refresh.')
        this.setState({ loadingCreate: false })
        this.handleClose()
      })
  }
  handleComplete = status => {
    this.setState({
      loadingCreate: true
    })
    this.props
      .updateCompleteGroup({
        variables: {
          isCompleted: status,
          id: this.state.event.id,
          userId: global.localStorage.getItem(GC_USER_ID)
        }
      })
      .then(() => {
        this.setState({ loadingCreate: false })
        this.handleClose()
      })
      .catch(error => {
        console.log(error.message + ' Please refresh.')
        this.setState({ loadingCreate: false })
        this.handleClose()
      })
  }

  handleDoneRoutine = str => {
    if (this.state.event.type === 'recur') {
      this.handleCreate(true, '', '', '')
    } else if (this.state.event.type === 'one') {
      if (str.includes('Done')) {
        this.handleComplete(true)
      } else {
        this.handleComplete(false)
      }
    }
  }

  handleDone = str => {
    this.setState({ loading: true })
    this.props
      .updateEventType({
        variables: {
          id: this.state.event.id,
          userId: global.localStorage.getItem(GC_USER_ID),
          eventType: str
        }
      })
      .then(() => {
        this.setState({ loading: false })
        this.handleClose()
      })
      .catch(error => {
        console.log(error.message + ' Please refresh.')
        this.setState({ loading: false })
        this.handleClose()
      })
  }

  render() {
    return (
      <div>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.open}
          onClose={this.handleClose}
          className="modalAddToday"
          disableAutoFocus
        >
          <Paper className="paperAddToday" style={{ borderRadius: 16 }}>
            {this.props.currentBookPref.loading ? (
              <Loading />
            ) : (
              <div id="GetUpTime" className="divAddTpday">
                <div className="divClearButton">
                  <IconButton
                    className="btn btn-default btn-style"
                    onClick={this.handleClose}
                  >
                    <ClearIcon className="iconClear" />
                  </IconButton>
                </div>
                <List>
                  <ListItem key={'time-range'} className="listItemGetUpTime">
                    <ListItemIcon>
                      <ChromeReaderModeIcon className="iconGetUpTimeView" />
                    </ListItemIcon>
                    <ListItemText
                      className="weightText"
                      primary={
                        this.state.event.startedAt === ''
                          ? moment(
                              new Date(this.state.event.completedAt)
                            ).format('HH:mm')
                          : moment(new Date(this.state.event.startedAt)).format(
                              'HH:mm'
                            ) +
                            '~' +
                            moment(
                              new Date(this.state.event.completedAt)
                            ).format('HH:mm')
                      }
                      classes={{
                        primary: 'textGetUpTimeView',
                        secondary: 'textGetUpDate'
                      }}
                      secondary={
                        'On ' +
                        moment(new Date(this.state.event.completedAt)).format(
                          'l'
                        )
                      }
                    />
                    <IconButton
                      onClick={() =>
                        this.handleSessionEdit(
                          'edit',
                          this.state.event.dataOrigin,
                          ''
                        )
                      }
                      className="iconBtnCheck"
                      size="small"
                    >
                      <EditIcon
                        style={{
                          color: 'lightgrey',
                          fontSize: 20
                        }}
                      />
                    </IconButton>
                    <IconButton
                      onClick={this.handleOpenDelete}
                      className="iconBtnCheck"
                      size="small"
                    >
                      <DeleteIcon
                        style={{
                          color: 'lightgrey',
                          fontSize: 20
                        }}
                      />
                    </IconButton>
                  </ListItem>
                  {this.state.event.tracker && (
                    <ListItem
                      key={`sessiodetail-${this.state.event.id}`}
                      className="listItemSessionView"
                    >
                      {this.state.event.tracker.name !== '' && (
                        <Paper className="paperWidget">
                          <Typography
                            style={{ color: 'dimgrey', fontSize: 18 }}
                          >
                            {this.state.event.tracker.name}
                          </Typography>
                          <Typography
                            style={{ color: 'lightgrey', fontSize: 12 }}
                          >
                            Tracker Name
                          </Typography>
                        </Paper>
                      )}
                      {this.state.event.tracker.isDuration && (
                        <Paper className="paperWidget">
                          <Typography
                            style={{ color: 'dimgrey', fontSize: 18 }}
                          >
                            {this.state.event.tracker.type !== 'sleep'
                              ? this.state.event.minutes
                              : parseFloat(
                                  this.state.event.minutes / 60,
                                  10
                                ).toFixed(1)}
                          </Typography>
                          <Typography
                            style={{ color: 'lightgrey', fontSize: 12 }}
                          >
                            {this.state.event.tracker.type !== 'sleep'
                              ? 'Mins'
                              : 'Hrs'}
                          </Typography>
                        </Paper>
                      )}
                      {this.state.event.book &&
                        this.state.event.book.name !== '' && (
                          <Paper className="paperWidget">
                            <Typography
                              style={{ color: 'dimgrey', fontSize: 18 }}
                            >
                              {this.state.event.book.name}
                            </Typography>
                            <Typography
                              style={{ color: 'lightgrey', fontSize: 12 }}
                            >
                              Book
                            </Typography>
                          </Paper>
                        )}
                    </ListItem>
                  )}

                  {this.state.event.options && (
                    <ListItem
                      key={`sessiodetail-1-${this.state.event.id}`}
                      className="listItemSessionView"
                    >
                      {this.state.event.options.value !== '' && (
                        <Paper className="paperWidget">
                          <Typography
                            style={{ color: 'dimgrey', fontSize: 18 }}
                          >
                            {this.state.event.options.value}
                          </Typography>
                          <Typography
                            style={{ color: 'lightgrey', fontSize: 12 }}
                          >
                            {this.state.event.tracker &&
                            this.state.event.tracker.type === 'energy'
                              ? 'Energy level'
                              : this.state.event.tracker.type === 'bodyweight'
                                ? 'LB'
                                : this.state.event.tracker.type === 'sleep'
                                  ? 'Sleep Quality'
                                  : 'Value'}
                          </Typography>
                        </Paper>
                      )}
                      {this.state.event.options.pageStart && (
                        <Paper className="paperWidget">
                          <Typography
                            style={{ color: 'dimgrey', fontSize: 18 }}
                          >
                            {this.state.event.options.pageStart}
                          </Typography>
                          <Typography
                            style={{ color: 'lightgrey', fontSize: 12 }}
                          >
                            Start Page
                          </Typography>
                        </Paper>
                      )}
                      {this.state.event.options.pageEnd && (
                        <Paper className="paperWidget">
                          <Typography
                            style={{ color: 'dimgrey', fontSize: 18 }}
                          >
                            {this.state.event.options.pageEnd}
                          </Typography>
                          <Typography
                            style={{ color: 'lightgrey', fontSize: 12 }}
                          >
                            End Page
                          </Typography>
                        </Paper>
                      )}
                      {this.state.event.options.brianClearness && (
                        <Paper className="paperWidget">
                          <Typography
                            style={{ color: 'dimgrey', fontSize: 18 }}
                          >
                            {this.state.event.options.brianClearness}
                          </Typography>
                          <Typography
                            style={{ color: 'lightgrey', fontSize: 12 }}
                          >
                            Brain Clearness
                          </Typography>
                        </Paper>
                      )}
                      {this.state.event.options.isNap && (
                        <Paper className="paperWidget">
                          <Typography
                            style={{ color: 'dimgrey', fontSize: 18 }}
                          >
                            Nap
                          </Typography>
                          <Typography
                            style={{ color: 'lightgrey', fontSize: 12 }}
                          >
                            Sleep type
                          </Typography>
                        </Paper>
                      )}
                    </ListItem>
                  )}

                  {this.state.event.task && (
                    <ListItem
                      key={`sessiodetail-2-${this.state.event.subtask.id}`}
                      className="listItemSessionView"
                    >
                      {this.state.event.task &&
                        this.state.event.task.name !== '' && (
                          <Paper className="paperWidget">
                            <Typography
                              style={{ color: 'dimgrey', fontSize: 18 }}
                            >
                              {this.state.event.task.name}
                            </Typography>
                            <Typography
                              style={{ color: 'lightgrey', fontSize: 12 }}
                            >
                              Task
                            </Typography>
                          </Paper>
                        )}
                      {this.state.event.subtask.name !== '' && (
                        <Paper className="paperWidget">
                          <Typography
                            style={{ color: 'dimgrey', fontSize: 18 }}
                          >
                            {this.state.event.subtask.name}
                          </Typography>
                          <Typography
                            style={{ color: 'lightgrey', fontSize: 12 }}
                          >
                            Subtask
                          </Typography>
                        </Paper>
                      )}
                    </ListItem>
                  )}
                  {(this.state.event.mood ||
                    this.state.event.comment ||
                    (this.state.event.eventType &&
                      this.state.event.eventType.includes(
                        'happenedRoutine'
                      ))) && (
                    <ListItem
                      key={`sessioninfo-${this.state.event.id}`}
                      className="listItemSessionView"
                    >
                      {this.state.event.mood !== 0 && (
                        <div className="divWidgetMood">
                          <Paper className="paperWidgetMood">
                            <Typography
                              style={{ color: 'dimgrey', fontSize: 18 }}
                            >
                              {this.state.event.mood === 10
                                ? '🤣'
                                : this.state.event.mood === 9
                                  ? '😆'
                                  : this.state.event.mood === 8
                                    ? '😁'
                                    : this.state.event.mood === 7
                                      ? '😀'
                                      : this.state.event.mood === 6
                                        ? '🙂'
                                        : this.state.event.mood === 5
                                          ? '😞'
                                          : this.state.event.mood === 4
                                            ? '️☹️'
                                            : this.state.event.mood === 3
                                              ? '😢'
                                              : this.state.event.mood === 2
                                                ? '😡'
                                                : this.state.event.mood === 1
                                                  ? '😫'
                                                  : ''}
                            </Typography>
                          </Paper>
                        </div>
                      )}

                      {this.state.event.comment !== '' && (
                        <Paper className="paperWidgetComment">
                          <Typography
                            style={{ color: 'lightgrey', fontSize: 12 }}
                          >
                            Comment
                          </Typography>
                          <Typography
                            style={{ color: 'dimgrey', fontSize: 18 }}
                          >
                            {this.state.event.comment}
                          </Typography>
                        </Paper>
                      )}
                      {this.state.event.eventType.includes(
                        'happenedRoutine'
                      ) && (
                        <Paper className="paperWidgetComment">
                          <Typography
                            style={{ color: 'lightgrey', fontSize: 12 }}
                          >
                            From
                          </Typography>
                          <Typography
                            style={{ color: 'dimgrey', fontSize: 18 }}
                          >
                            {this.state.event.eventType}
                          </Typography>
                        </Paper>
                      )}
                    </ListItem>
                  )}
                  {this.state.event.eventType !== 'routine' && (
                    <ListItem key={'event-info'} className="listItemGetUpTime">
                      <ListItemText
                        className="weightTextLeft"
                        classes={{
                          secondary: 'textGetUpDate'
                        }}
                        secondary={
                          this.state.event.eventType &&
                          this.state.event.eventType.includes(
                            'happenedRoutine:'
                          )
                            ? this.state.event.eventType.substr(0, 15) +
                              ' • ' +
                              this.state.event.dataOrigin
                            : this.state.event.eventType +
                              ' • ' +
                              this.state.event.dataOrigin
                        }
                      />
                      {this.state.event.eventType &&
                        !this.state.event.eventType.includes('happened') && (
                          <IconButton
                            onClick={() =>
                              this.handleSessionEdit('add', 'alchmeyTimer', '')
                            }
                            className="iconBtnCheck"
                            size="small"
                          >
                            <PlayArrowIcon
                              style={{
                                color: 'lightgrey',
                                fontSize: 24
                              }}
                            />
                          </IconButton>
                        )}
                      {this.state.event.eventType &&
                        !this.state.event.eventType.includes('happened') && (
                          <IconButton
                            onClick={() =>
                              this.handleSessionEdit('add', 'manualAdd', '')
                            }
                            className="iconBtnCheck"
                            size="small"
                          >
                            <AddIcon
                              style={{
                                color: 'lightgrey',
                                fontSize: 24
                              }}
                            />
                          </IconButton>
                        )}
                      {this.state.event.eventType &&
                        !this.state.event.eventType.includes('happened') && (
                          <IconButton
                            onClick={() =>
                              this.handleSessionEditDone('add', 'manualAdd', '')
                            }
                            className="iconBtnCheck"
                            size="small"
                          >
                            <CheckIcon
                              style={{
                                color: 'lightgrey',
                                fontSize: 24
                              }}
                            />
                          </IconButton>
                        )}
                    </ListItem>
                  )}
                  {this.state.event.eventType === 'routine' &&
                    this.state.event.trackers.map((e, index) => (
                      <ListItem
                        key={index}
                        dense
                        className="listItemSessionViewTight"
                      >
                        <Paper
                          className="paperBlock"
                          style={{ borderRadius: 36 }}
                        >
                          <div
                            key={`bookblock-key-${index}`}
                            className="bookBlockChecked"
                            style={{
                              backgroundColor: e.color,
                              opacity: 0.55
                            }}
                          >
                            <img
                              alt=""
                              className="iconTracker"
                              src={process.env.PUBLIC_URL + '/cloud_done.png'}
                            />
                            <Typography
                              variant="caption"
                              style={{
                                paddingLeft: 2,
                                paddingRight: 2,
                                textAlign: 'center',
                                fontSize: 12,
                                color: 'white',
                                lineHeight: 1.1
                              }}
                            >
                              {e.name}
                            </Typography>
                          </div>
                        </Paper>
                        <ListItemText />
                        <IconButton
                          onClick={() =>
                            this.handleSessionEditRoutine(
                              false,
                              'add',
                              'alchmeyTimer',
                              e
                            )
                          }
                          className="iconBtnCheck"
                          size="small"
                        >
                          <PlayArrowIcon
                            style={{
                              color: 'lightgrey',
                              fontSize: 24
                            }}
                          />
                        </IconButton>
                        <IconButton
                          onClick={() =>
                            this.handleSessionEditRoutine(
                              false,
                              'add',
                              'manualAdd',
                              e
                            )
                          }
                          className="iconBtnCheck"
                          size="small"
                        >
                          <AddIcon
                            style={{
                              color: 'lightgrey',
                              fontSize: 24
                            }}
                          />
                        </IconButton>
                        <IconButton
                          onClick={() =>
                            this.handleSessionEditRoutine(
                              true,
                              'add',
                              'manualAdd',
                              e
                            )
                          }
                          className="iconBtnCheck"
                          size="small"
                        >
                          <CheckIcon
                            style={{
                              color: 'lightgrey',
                              fontSize: 24
                            }}
                          />
                        </IconButton>
                      </ListItem>
                    ))}
                  <ListItem
                    key={'event-info-done'}
                    className="listItemGetUpTime"
                  >
                    {this.state.event.eventType === 'routine' ? (
                      <ListItemText
                        className="weightTextLeft"
                        classes={{
                          secondary: 'textGetUpDate'
                        }}
                        secondary={
                          this.state.event.eventType +
                          ' • ' +
                          this.state.event.type
                        }
                      />
                    ) : (
                      <ListItemText />
                    )}
                    {this.state.event.eventType &&
                      !this.state.event.eventType.includes('happened') && (
                        <div>
                          {this.state.loading ? (
                            <Loading />
                          ) : this.state.loadingCreate ? (
                            <Loading />
                          ) : this.state.loadingAddTo ? (
                            <Loading />
                          ) : this.state.event.eventType.includes('Done') ||
                          this.state.event.isCompleted ? (
                            <Button
                              onClick={
                                this.state.event.eventType === 'routine'
                                  ? () => this.handleDoneRoutine('routine')
                                  : () => this.handleDone('plan')
                              }
                              className="iconBtnCheck"
                              size="small"
                            >
                              <span style={{ color: 'grey', fontSize: 15 }}>
                                Reopen
                              </span>
                              <ChevronRightIcon
                                style={{
                                  color: 'lightgrey',
                                  fontSize: 20,
                                  paddingLeft: 10
                                }}
                              />
                            </Button>
                          ) : (
                            <Button
                              onClick={
                                this.state.event.eventType === 'routine'
                                  ? () => this.handleDoneRoutine('routineDone')
                                  : () => this.handleDone('planDone')
                              }
                              className="iconBtnCheck"
                              size="small"
                            >
                              <span style={{ color: 'grey', fontSize: 15 }}>
                                Complete
                              </span>
                              <CheckIcon
                                style={{
                                  color: 'lightgrey',
                                  fontSize: 20,
                                  paddingLeft: 10
                                }}
                              />
                            </Button>
                          )}
                        </div>
                      )}
                  </ListItem>
                </List>
              </div>
            )}
          </Paper>
        </Modal>
        <EventEditModal
          open={this.state.OpenAdd}
          onClose={this.handleCloseAdd}
          openTimer={this.state.OpenTimer}
          onCloseTimer={this.handleCloseTimer}
          event={
            this.state.action === 'add' ? this.state.newEvent : this.state.event
          }
          action={this.state.action}
          origin={this.state.origin}
          from={this.state.happenedFromID}
        />
        <GroupEditModal
          open={this.state.openEdit}
          onClose={this.handleCloseEdit}
          id={this.state.event.id || ''}
          action={this.state.action}
        />
        <DeleteModal
          open={this.state.OpenDelete}
          onClose={this.handleCloseDelete}
          yes={() => this.handleDelete(this.state.event.id)}
          loading={this.state.loadingDel}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/EventView.js